import React, { useState, useEffect, useMemo } from 'react';
import {
    Row, Col,
    Card, CardBody,
    CardTitle, Table, Label, FormGroup, Input, Button, Badge, Modal, ModalHeader, ModalBody, ModalFooter,
    Nav,
    NavLink,
    NavItem,
    Spinner
} from 'reactstrap';
import Tabs from 'react-responsive-tabs';
import {
    getCenterListSuggestionAPI, getTreatmentDoneStatsAPI, getPatientStatusStatsAPI, getPatientRegistrationStatsAPI,
    getTreatmentDoneStatsDetailAPI, getPatientStatusStatsDetailAPI, getPatientRegistrationStatsDetailAPI,
    getDiagnosisReportAPI,
    getECDIReportAPI
} from './../../api/network/Api';

import PageTitle from '../../Layout/AppMain/PageTitle';
import axios from "axios";
import { toast, Bounce } from 'react-toastify';
import Pagination from '../../api/helperComponents/Pagination';
import { useHistory, useParams } from 'react-router-dom';
import userUtil from '../../utils/UserUtils';
import Loader from '../../api/helperComponents/Loader';
import BreadCrumb from '../../api/helperComponents/BreadCrumb';
import VisitProgressReport from './VisitProgressReport';
import { Bar, Doughnut } from 'react-chartjs-2';
import { Chart as ChartJS, ArcElement, Tooltip, Legend, Title, CategoryScale, LinearScale, BarElement } from 'chart.js';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye } from '@fortawesome/free-solid-svg-icons';
import DpepReport from './DpepReport';

// Ensure Chart.js components are registered after all imports
ChartJS.register(ArcElement, Tooltip, Legend, Title, CategoryScale, LinearScale, BarElement);

const SuperAdminReporting = () => {
    const history = useHistory()
    const params = useParams()
    const cancelTokenSource = axios.CancelToken.source();
    const [patientList, setPatientList] = useState([]);
    const [isLoader, setIsLoader] = useState(false);
    const [suggestions, setSuggestions] = useState([]);
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [searchQuery, setSearchQuery] = useState("");
    const [selectedCenter, setSelectedCenter] = useState(userUtil?.userData?.center_id);
    const [startDateError, setStartDateError] = useState("");
    const [endDateError, setEndDateError] = useState("");
    const [timeFrame, setTimeFrame] = useState("Today");
    const [patientStatus, setPatientStatus] = useState("Active");
    const [patientStatusAfter, setPatientStatusAfter] = useState("Active");
    const [treatmentDoneStats, setTreatmentDoneStats] = useState(null);
    const [patientStatusStats, setPatientStatusStats] = useState(null);
    const [patientRegistrationStats, setPatientRegistrationStats] = useState(null);
    const [detailData, setDetailData] = useState(null);
    const [detailTitle, setDetailTitle] = useState('');
    const [selectedTab, setSelectedTab] = useState(0);
    const [diagnosisReportData, setDiagnosisReportData] = useState([]);

    const [age, setAge] = useState(null);
    const [ageType, setAgeType] = useState(null);
    const [deformityGrade, setDeformityGrade] = useState(null);
    const [deformityType, setDeformityType] = useState(null);
    const [gender, setGender] = useState(null);
    const [eCDIReportData, setECDIReportData] = useState([]);
    const [eCDIReportDataCount, setECDIReportDataCount] = useState(0);
    const [eCDIReportGraphData, setECDIReportGraphData] = useState(null);
    const [eCDIPage, setECDIPage] = useState(0);
    const [eCDIRowsPerPage, setECDIRowsPerPage] = useState(10);
    const [selectedDeformityGrades, setSelectedDeformityGrades] = useState([]);
    const [selectedDeformityTypes, setSelectedDeformityTypes] = useState([]);
    const [isEcdIModalOpen, setIsEcdIModalOpen] = useState(false);
    const [selectedEcdIPatient, setSelectedEcdIPatient] = useState(null);
    const [viewTab, setViewTab] = useState('list');
    const openEcdIModal = (patient) => { setSelectedEcdIPatient(patient); setIsEcdIModalOpen(true); };
    const closeEcdIModal = () => { setIsEcdIModalOpen(false); setSelectedEcdIPatient(null); };

    const clearECDIFilters = () => {
        setAge(null);
        setAgeType(null);
        setGender(null);
        setDeformityGrade(null);
        setSelectedDeformityGrades([]);
        setSelectedDeformityTypes([]);
    };

    const removeDeformityGrade = (val) => {
        setSelectedDeformityGrades((prev) => prev.filter((v) => v !== val));
    };

    const removeDeformityType = (val) => {
        setSelectedDeformityTypes((prev) => prev.filter((v) => v !== val));
    };

    const getDeformityGradeLabel = (val) => {
        try { return getDeformityGradeOfEcdi(String(val)); } catch { return val; }
    };
    const getDeformityTypeLabel = (val) => {
        try { return getDeformityTypeOfEcdi(String(val)); } catch { return val; }
    };
    const deformityGradeAllValues = ['0', '1', '2', '3', '4', '5', '6', '7', '8'];
    const deformityTypeAllValues = ['0', '1', '2', '3', '4', '5'];

    const chartOptionsBar = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: { legend: { display: false } },
        scales: { y: { beginAtZero: true, ticks: { precision: 0 } } },
    };
    const chartOptionsDoughnut = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: { legend: { position: 'bottom' } },
        cutout: '55%',
    };

    const tabsContent = [
        { title: 'Patient Status', content: 'patientStatus' },
        { title: 'Diagnosis', content: 'Diagnosis' },
        { title: 'Visit Progress Report', content: 'visitProgressReport' },
        { title: 'ECDI', content: 'ecdi' },
        { title: 'DPEP', content: 'dpep' },
    ];
    const spinalDiagnososBind = [
        { SPONDYLOSIS: { key: 'SPONDYLOSIS', value: 1, name: 'Spondylosis' } },
        { SPONDYLOSIS: { key: 'DDD', value: 2, name: 'DDD' } },
        { DISC_BULGE: { key: 'DISC_BULGE', value: 3, name: 'Disc Bulge' } },
        { DISC_PROTRUSION: { key: 'DISC_PROTRUSION', value: 4, name: 'Disc Protrusion' } },
        { SPONDYLOLISTHESIS: { key: 'SPONDYLOLISTHESIS', value: 5, name: 'Spondylolisthesis' } },
        { SCOLIOSIS: { key: 'SCOLIOSIS', value: 6, name: 'Scoliosis' } },
        { DEGENERATIVE_SCOLIOSIS: { key: 'DEGENERATIVE_SCOLIOSIS', value: 7, name: 'Degenerative Scoliosis' } },
        { OSTEOPOROSIS: { key: 'OSTEOPOROSIS', value: 8, name: 'Osteoporosis' } },
        { OCHRONOSIS: { key: 'OCHRONOSIS', value: 9, name: 'Ochronosis' } },
        { COCCYDYNIA: { key: 'COCCYDYNIA', value: 10, name: 'Coccydynia' } },
        { ANKYLOSIS: { key: 'ANKYLOSIS', value: 11, name: 'Ankylosis' } },
        { SPONDYLITIS: { key: 'SPONDYLITIS', value: 12, name: 'Spondylitis' } },
        { SPINAL_STENOSIS: { key: 'SPINAL_STENOSIS', value: 13, name: 'Spinal Stenosis' } },
        { RADICULITIS: { key: 'RADICULITIS', value: 14, name: 'Radiculitis' } },
        { RADICULOPATHY: { key: 'RADICULOPATHY', value: 15, name: 'Radiculopathy' } },
        { MYELOPATHY: { key: 'MYELOPATHY', value: 16, name: 'Myelopathy' } },
        { SPINOCEREBELLAR_DISEASE: { key: 'SPINOCEREBELLAR_DISEASE', value: 17, name: 'Spinocerebellar Disease' } },
        { MOTOR_NEURON_DISEASE: { key: 'MOTOR_NEURON_DISEASE', value: 18, name: 'Motor Neuron Disease' } },
        { SYRINGOMYELIA: { key: 'SYRINGOMYELIA', value: 19, name: 'Syringomyelia' } },
        { CERVICAL_DYSTONIA: { key: 'CERVICAL_DYSTONIA', value: 20, name: 'Cervical Dystonia' } },
        { NOT_APPLICABLE: { key: 'NOT_APPLICABLE', value: 21, name: 'Not Applicable' } },
        { OTHER: { key: 'OTHER', value: 22, name: 'Other' } },
    ]
    const rheumatoid_arthritis = [
        { JUVINILE: { key: 'JUVINILE', value: 1, name: 'Juvinile' } },
        { PAUCI_ARTICULAR: { key: 'PAUCI_ARTICULAR', value: 2, name: 'Pauci Articular' } },
        { POLY_ARTICUALAR: { key: 'POLY_ARTICUALAR', value: 3, name: 'Poly Articular' } },
        { RA_POSITIVE: { key: 'RA_POSITIVE', value: 4, name: '*RA +ve' } },
        { ANTI_CPP_POSITIVE: { key: 'ANTI_CPP_POSITIVE', value: 5, name: 'Anti-CCP +ve' } },
        { RA_NEGATIVE: { key: 'RA_NEGATIVE', value: 6, name: '*RA-ve' } },
        { ANTI_CPP_NEGATIVE: { key: 'ANTI_CPP_NEGATIVE', value: 7, name: 'Anti-CCP -ve' } },
        { NOT_APPLICABLE: { key: 'NOT_APPLICABLE', value: 8, name: 'Not Applicable' } },
    ]

    useEffect(() => {
        const elements = document.querySelectorAll('.react-autosuggest__suggestions-container');
        if (suggestions.length == 0) {
            elements.forEach(element => { element.style.display = 'none'; });
        } else {
            elements.forEach(element => { element.style.display = 'block'; });
        }
    }, [suggestions]);

    function createQueryString(filterType, centerId, startDate, endDate) {
        let queryString = '';
        if (filterType !== null) queryString += `filter_type=${encodeURIComponent(filterType)}&`;
        if (centerId !== null && centerId !== "") queryString += `center_id=${encodeURIComponent(centerId)}&`;
        if (startDate !== null) queryString += `from_date=${encodeURIComponent(startDate)}&`;
        if (endDate !== null) queryString += `to_date=${encodeURIComponent(endDate)}&`;
        if (queryString.length > 0) queryString = queryString.slice(0, -1);
        return queryString;
    }

    const handleSearch = (e) => {
        setDetailData(null)
        const queryString = createQueryString(timeFrame, selectedCenter, startDate, endDate);
        if (selectedTab == 0) {
            getTreatmentDoneStats(queryString)
            getPatientStatusStats(queryString)
            getPatientRegistrationStats(queryString)
        } else if (selectedTab == 3) {
            const fullQuery = buildECDIQuery();
            if (!fullQuery) {
                if (!selectedDeformityGrades || selectedDeformityGrades.length === 0) toast('Please select at least one deformity grade', { type: 'warning' });
                else if (!selectedDeformityTypes || selectedDeformityTypes.length === 0) toast('Please select at least one deformity type', { type: 'warning' });
                return;
            }
            setECDIPage(0);
            getECDIReport(fullQuery, 0, eCDIRowsPerPage)
            getECDIReportGraph(fullQuery)
        } else {
            getDiagnosisReport(queryString)
        }
    }

    const getTreatmentDoneStats = async (queryString) => {
        setIsLoader(true)
        const response = await getTreatmentDoneStatsAPI(queryString, cancelTokenSource.token)
        setIsLoader(false)
        if (response.success) {
            setTreatmentDoneStats(response?.data)
        } else {
            toast(response?.system_message, { transition: Bounce, closeButton: true, autoClose: 5000, position: 'bottom-center', type: 'error' });
        }
    }
    const getPatientStatusStats = async (queryString) => {
        setIsLoader(true)
        const response = await getPatientStatusStatsAPI(queryString + `&status=${patientStatus}`, cancelTokenSource.token)
        setIsLoader(false)
        if (response.success) {
            setPatientStatusStats(response?.data)
            setPatientStatusAfter(patientStatus)
        } else {
            toast(response?.system_message, { transition: Bounce, closeButton: true, autoClose: 5000, position: 'bottom-center', type: 'error' });
        }
    }
    const getPatientRegistrationStats = async (queryString) => {
        setIsLoader(true)
        const response = await getPatientRegistrationStatsAPI(queryString, cancelTokenSource.token)
        setIsLoader(false)
        if (response.success) {
            setPatientRegistrationStats(response?.data)
        } else {
            toast(response?.system_message, { transition: Bounce, closeButton: true, autoClose: 5000, position: 'bottom-center', type: 'error' });
        }
    }
    const getTreatmentDoneStatsDetail = async (queryString) => {
        setDetailTitle('Total Treatment Done')
        setIsLoader(true)
        const response = await getTreatmentDoneStatsDetailAPI(queryString + '&list=true&offset=0&limit=5000', cancelTokenSource.token)
        setIsLoader(false)
        if (response.success) {
            setDetailData(response?.data?.count?.rows)
        } else {
            toast(response?.system_message, { transition: Bounce, closeButton: true, autoClose: 5000, position: 'bottom-center', type: 'error' });
        }
    }
    const getPatientStatusStatsDetail = async (queryString) => {
        setDetailTitle(`Patient Status (${patientStatus})`)
        setIsLoader(true)
        const response = await getPatientStatusStatsDetailAPI(queryString + `&list=true&status=${patientStatus}&offset=0&limit=5000`, cancelTokenSource.token)
        setIsLoader(false)
        if (response.success) {
            setDetailData(response?.data?.count?.rows)
        } else {
            toast(response?.system_message, { transition: Bounce, closeButton: true, autoClose: 5000, position: 'bottom-center', type: 'error' });
        }
    }
    const getPatientRegistrationStatsDetail = async (queryString) => {
        setIsLoader(true)
        setDetailTitle(`Total Patient Registered`)
        const response = await getPatientRegistrationStatsDetailAPI(queryString + '&list=true&offset=0&limit=5000', cancelTokenSource.token)
        setIsLoader(false)
        if (response.success) {
            setDetailData(response?.data?.count?.rows)
        } else {
            toast(response?.system_message, { transition: Bounce, closeButton: true, autoClose: 5000, position: 'bottom-center', type: 'error' });
        }
    }
    const getDiagnosisReport = async (queryString) => {
        setIsLoader(true)
        const response = await getDiagnosisReportAPI(queryString + '&offset=0&limit=5000', cancelTokenSource.token)
        setIsLoader(false)
        if (response.success) {
            setDiagnosisReportData(response?.data?.report?.rows)
        } else {
            toast(response?.system_message, { transition: Bounce, closeButton: true, autoClose: 5000, position: 'bottom-center', type: 'error' });
        }
    }

    const buildECDIQuery = () => {
        const base = createQueryString(timeFrame, selectedCenter, startDate, endDate);
        const params = [];
        if (ageType && age) { params.push(`age_type=${encodeURIComponent(ageType)}`); params.push(`age=${encodeURIComponent(age)}`); }
        if (gender) params.push(`gender=${encodeURIComponent(gender)}`);
        if (!selectedDeformityGrades || selectedDeformityGrades.length === 0) return null;
        if (!selectedDeformityTypes || selectedDeformityTypes.length === 0) return null;
        params.push(`deformity_grade=${selectedDeformityGrades.join(',')}`);
        params.push(`deformity_type=${selectedDeformityTypes.join(',')}`);
        return base + (params.length ? `&${params.join('&')}` : '');
    };

    const getECDIReport = async (queryString, pageOverride, rowsOverride) => {
        setIsLoader(true)
        const page = typeof pageOverride === 'number' ? pageOverride : eCDIPage;
        const limit = typeof rowsOverride === 'number' ? rowsOverride : eCDIRowsPerPage;
        const offset = page * limit;
        const response = await getECDIReportAPI(queryString + `&offset=${offset}&limit=${limit}&list=true`, cancelTokenSource.token)
        setIsLoader(false)
        if (response.success) {
            setECDIReportData(response?.data?.report?.rows)
            setECDIReportDataCount(response?.data?.report?.count)
        } else {
            toast(response?.system_message, { transition: Bounce, closeButton: true, autoClose: 5000, position: 'bottom-center', type: 'error' });
        }
    }

    const getECDIReportGraph = async (queryString) => {
        setIsLoader(true)
        const response = await getECDIReportAPI(queryString + `&graph=true`, cancelTokenSource.token)
        setIsLoader(false)
        if (response.success) {
            setECDIReportGraphData(response?.data?.report || [])
        } else {
            toast(response?.system_message, { transition: Bounce, closeButton: true, autoClose: 5000, position: 'bottom-center', type: 'error' });
        }
    }

    const handleECDIPageChange = (newPage) => {
        const q = buildECDIQuery();
        if (!q) return;
        const pageIndex = newPage - 1;
        setECDIPage(pageIndex);
        getECDIReport(q, pageIndex, eCDIRowsPerPage);
    };
    const handleECDIRowsPerPageChange = (e) => {
        const newRows = Number(e.target.value) || 10;
        const q = buildECDIQuery();
        setECDIRowsPerPage(newRows);
        setECDIPage(0);
        if (!q) return;
        getECDIReport(q, 0, newRows);
    };

    const handleClick = (key) => {
        if (key == 'treatmentDoneStats') {
            const queryString = createQueryString(timeFrame, selectedCenter, startDate, endDate);
            getTreatmentDoneStatsDetail(queryString)
        }
        if (key == 'patientStatusStats') {
            const queryString = createQueryString(timeFrame, selectedCenter, startDate, endDate);
            getPatientStatusStatsDetail(queryString)
        }
        if (key == 'patientRegistrationStats') {
            const queryString = createQueryString(timeFrame, selectedCenter, startDate, endDate);
            getPatientRegistrationStatsDetail(queryString)
        }
    }
    const handleClickTab = (e) => {
        setSelectedTab(e)
        setTimeFrame('Today')
        setStartDate(null)
        setEndDate(null)
        setPatientStatus("Active");
    }
    const getTabs = () => tabsContent.map((tab, index) => ({ title: tab.title, key: index }));

    const getTotalCdiScore = (item) => {
        if (item) {
            return calculateSubScore('c2_c3', item) + calculateSubScore('c3_c4', item) + calculateSubScore('c4_c5', item) + calculateSubScore('c5_c6', item) + calculateSubScore('c6_c7', item)
        } else { return '0'; }
    }
    function calculateSubScore(level, data) {
        const lateral = Number(data[`${level}_olisthesis_lateral`]);
        const flexion = Number(data[`${level}_olisthesis_flexion`]);
        const extension = Number(data[`${level}_olisthesis_extension`]);
        const anterior = Number(data[`${level}_olisthesis_anterior`]);
        const posterior = Number(data[`${level}_olisthesis_posterior`]);
        const discSpaceNarrowing = Number(data[`${level}_disc_space_narrowing`]);
        const maxFlexionExtension = Math.max(flexion, extension);
        const maxAnteriorPosterior = Math.max(anterior, posterior);
        return lateral + maxFlexionExtension + maxAnteriorPosterior + discSpaceNarrowing;
    }
    const getNameOfEcdi = (nameId) => {
        if (nameId == '0') return 'Normal'
        if (nameId == '1') return 'Instability'
        if (nameId == '2') return 'Mild'
        if (nameId == '3') return 'Moderate'
        if (nameId == '4') return 'Severe'
        if (nameId == '5') return 'Very Severe'
    }
    const getDeformityGradeOfEcdi = (nameId) => {
        if (nameId == '0') return '0 - Normal'
        if (nameId == '1') return 'I - Olisthesis'
        if (nameId == '2') return 'I - A (Dynamic)'
        if (nameId == '3') return 'I - B (Dynamic)'
        if (nameId == '4') return 'I - C (Dynamic)'
        if (nameId == '5') return 'II - A (Static)'
        if (nameId == '6') return 'II - B (Static)'
        if (nameId == '7') return 'II - C (Static)'
        if (nameId == '8') return 'III - Rigid'
    }
    const getDeformityTypeOfEcdi = (nameId) => {
        if (nameId == '0') return 'Normal'
        if (nameId == '1') return 'Instability'
        if (nameId == '2') return 'Mild'
        if (nameId == '3') return 'Moderate'
        if (nameId == '4') return 'Severe'
        if (nameId == '5') return 'Very Severe'
    }

    function convertToCSV(table) {
        var csv = [];
        for (var i = 0; i < table.rows.length; i++) {
            var row = [];
            for (var j = 0; j < table.rows[i].cells.length; j++) {
                var cellText = table.rows[i].cells[j].textContent;
                if (cellText.includes(',')) { cellText = '"' + cellText + '"'; }
                row.push(cellText);
            }
            csv.push(row.join(','));
        }
        return csv.join('\n');
    }

    function downloadCSV(csv, filename) {
        var csvFile = new Blob([csv], { type: "text/csv" });
        var downloadLink = document.createElement("a");
        downloadLink.download = filename;
        downloadLink.href = window.URL.createObjectURL(csvFile);
        downloadLink.style.display = "none";
        document.body.appendChild(downloadLink);
        downloadLink.click();
    }

    const handleDownload = () => {
        var table = document.getElementById("data-table");
        var csv = convertToCSV(table);
        var filename = "table-data.csv";
        downloadCSV(csv, filename);
    }
    const getSpinalDiagnosisName = (data) => {
        const filteredData = spinalDiagnososBind.filter(item => data.includes(Object.values(item)[0].value));
        const names = filteredData?.map(item => Object.values(item)[0].name);
        return names.join(', ');
    }
    const getRheumatoidArthritisName = (data) => {
        const filteredData = rheumatoid_arthritis.filter(item => data.includes(Object.values(item)[0].value));
        const names = filteredData?.map(item => Object.values(item)[0].name);
        return names.join(', ');
    }
    const handleClickDashboard = (e, data) => {
        localStorage.setItem('patientNameID', data?.mrn)
        history.push(`/patient/dashboard/${data?.id}`)
    }

    const ecdiChartData = useMemo(() => {
        try {
            const palette = ['#4dc9f6', '#f67019', '#f53794', '#537bc4', '#acc236', '#166a8f', '#00a950', '#58595b', '#8549ba'];
            let deformityLabels = [];
            let deformityData = [];
            let typeLabels = [];
            let typeData = [];
console.log(eCDIReportGraphData,'eCDIReportGraphData')
            if (Array.isArray(eCDIReportGraphData) && eCDIReportGraphData.length > 0 && eCDIReportGraphData[0]?.category !== undefined) {
                const deformityItems = eCDIReportGraphData.filter(i => i.category === 'deformity');
                const typeItems = eCDIReportGraphData.filter(i => i.category === 'type');
                deformityLabels = deformityItems.map(i => getDeformityGradeLabel(String(i.value)));
                deformityData = deformityItems.map(i => Number(i.count || 0));
                typeLabels = typeItems.map(i => getDeformityTypeLabel(String(i.value)));
                typeData = typeItems.map(i => Number(i.count || 0));
            } 

            return {
                deformity: {
                    labels: deformityLabels,
                    datasets: [{ data: deformityData, backgroundColor: deformityLabels.map((_, i) => palette[i % palette.length]), borderWidth: 1 }]
                },
                type: {
                    labels: typeLabels,
                    datasets: [{ data: typeData, backgroundColor: typeLabels.map((_, i) => palette[i % palette.length]), borderWidth: 1 }]
                }
            };
        } catch (_) {
            return { deformity: { labels: [], datasets: [{ data: [] }] }, type: { labels: [], datasets: [{ data: [] }] } };
        }
    }, [eCDIReportData, eCDIReportGraphData]);

    return (
        <div>
            {isLoader && (<Loader />)}

            <BreadCrumb items={[
                { label: "Dashboard", url: "/" },
                { label: "Reporting" }
            ]} />
            <Tabs tabsWrapperClass="body-tabs body-tabs-layout" onChange={(e) => { handleClickTab(e) }} transform={false} showInkBar={true} items={getTabs()} />
            {selectedTab != 2 && selectedTab != 4 && (
                <Card className="main-card mb-3">
                    <CardBody>
                        <CardTitle className="flex-space-between">
                            {selectedTab == 0 ? "Patient Status Wise Report" : selectedTab == 1 ? "Diagnosis Wise Report" : selectedTab == 3 ? "ECDI Report" : "Visit Progress Report"}
                        </CardTitle>
                        <div>
                            <Row className="treatment-liest-container">
                                <Col md="3" >
                                    <FormGroup>
                                        <Label for="f_name">Select Time Frame</Label>
                                        <Input type="select" name="time_frame" id="time_frame" value={timeFrame} onChange={(e) => { setTimeFrame(e.target.value) }} >
                                            <option value="">Select</option>
                                            <option value="Today">Today</option>
                                            <option value="Yesterday">Yesterday</option>
                                            <option value="Last_7_days">Last 7 days</option>
                                            <option value="Last_15_days">Last 15 days</option>
                                            <option value="Last_month">Last Month</option>
                                            <option value="custom_date">Custom Date</option>
                                        </Input>
                                    </FormGroup>
                                </Col>
                                {timeFrame == "custom_date" && (
                                    <>
                                        <Col md="3" >
                                            <FormGroup>
                                                <Label for="f_name">Start Date</Label>
                                                <Input type="date" name="s_date" id="s_date" value={startDate || ''} onChange={(e) => { setStartDate(e.target.value) }} />
                                                <span style={{ color: 'red' }}>{startDateError}</span>
                                            </FormGroup>
                                        </Col>
                                        <Col md="3" >
                                            <FormGroup>
                                                <Label for="f_name">End Date</Label>
                                                <Input type="date" name="e_date" id="e_date" value={endDate || ''} onChange={(e) => { setEndDate(e.target.value) }} />
                                                <span style={{ color: 'red' }}>{endDateError}</span>
                                            </FormGroup>
                                        </Col>
                                    </>
                                )}
                                {selectedTab == 0 && (
                                    <Col md="3">
                                        <FormGroup>
                                            <Label for="f_name">Select Patient Status</Label>
                                            <Input type="select" name="patient_status" id="patient_status" value={patientStatus} onChange={(e) => { setPatientStatus(e.target.value) }} >
                                                <option value="Active">Active</option>
                                                <option value="Completed">Completed</option>
                                                <option value="LAMA">LAMA</option>
                                            </Input>
                                        </FormGroup>
                                    </Col>
                                )}
                                {selectedTab == 3 && (
                                    <>
                                        <Col md="12">
                                            <div className="p-3" style={{ background: '#f8fbfb', border: '1px solid #e3f1ef', borderRadius: 12 }}>
                                                <Row className="">
                                                    <Col md="3">
                                                        <FormGroup>
                                                            <Label for="age_type">Age Type</Label>
                                                            <Input type="select" name="age_type" id="age_type" value={ageType || ''} onChange={(e) => { setAgeType(e.target.value || null) }} >
                                                                <option value="">Select Type</option>
                                                                <option value="GREATER_THAN">GREATER THAN</option>
                                                                <option value="LESS_THAN">LESS THAN</option>
                                                            </Input>
                                                        </FormGroup>
                                                    </Col>
                                                    {ageType && (
                                                        <Col md="3">
                                                            <FormGroup>
                                                                <Label for="age">Age</Label>
                                                                <Input type="number" min="0" name="age" id="age" value={age || ''} onChange={(e) => { setAge(e.target.value || null) }} placeholder="e.g. 45" />
                                                            </FormGroup>
                                                        </Col>
                                                    )}
                                                    <Col md="3">
                                                        <FormGroup>
                                                            <Label for="gender">Gender</Label>
                                                            <Input type="select" name="gender" id="gender" value={gender || ''} onChange={(e) => { setGender(e.target.value || null) }} >
                                                                <option value="">All</option>
                                                                <option value="1">Male</option>
                                                                <option value="2">Female</option>
                                                                <option value="3">Other</option>
                                                            </Input>
                                                        </FormGroup>
                                                    </Col>
                                                    <Row>
                                                        <Col md="6">
                                                            <FormGroup>
                                                                <Label for="deformityGrade">Deformity Grade</Label>
                                                                <Input type="select" name="deformityGrade" id="deformityGrade" value={deformityGrade || ''} onChange={(e) => {
                                                                    const v = e.target.value;
                                                                    if (!v) return;
                                                                    if (v === 'ALL') { setSelectedDeformityGrades(deformityGradeAllValues); setDeformityGrade(''); return; }
                                                                    setSelectedDeformityGrades((prev) => prev.includes(v) ? prev : [...prev, v]);
                                                                    setDeformityGrade('');
                                                                }}>
                                                                    <option value="">Select Deformity Grade</option>
                                                                    <option value="ALL">Select All</option>
                                                                    {[
                                                                        { value: '0', label: '0 - Normal' },
                                                                        { value: '1', label: 'I - Olisthesis' },
                                                                        { value: '2', label: 'I - A (Dynamic)' },
                                                                        { value: '3', label: 'I - B (Dynamic)' },
                                                                        { value: '4', label: 'I - C (Dynamic)' },
                                                                        { value: '5', label: 'II - A (Static)' },
                                                                        { value: '6', label: 'II - B (Static)' },
                                                                        { value: '7', label: 'II - C (Static)' },
                                                                        { value: '8', label: 'III - Rigid' },
                                                                    ]
                                                                        .filter(opt => !selectedDeformityGrades.includes(opt.value))
                                                                        .map(opt => (<option key={opt.value} value={opt.value}>{opt.label}</option>))}
                                                                </Input>
                                                            </FormGroup>
                                                            {selectedDeformityGrades && selectedDeformityGrades.length > 0 && (
                                                                <Row>
                                                                    <Col md="12">
                                                                        <div className="mt-1" style={{ display: 'flex', flexWrap: 'wrap', gap: 8 }}>
                                                                            {selectedDeformityGrades.map((g) => (
                                                                                <Badge key={g} color="info" pill style={{ display: 'inline-flex', alignItems: 'center', paddingRight: 8 }}>
                                                                                    {getDeformityGradeLabel(g)}
                                                                                    <button type="button" onClick={() => removeDeformityGrade(g)} style={{ marginLeft: 8, border: 'none', background: 'transparent', color: 'inherit', cursor: 'pointer', lineHeight: 1 }} aria-label={`Remove ${getDeformityGradeLabel(g)}`}>×</button>
                                                                                </Badge>
                                                                            ))}
                                                                        </div>
                                                                    </Col>
                                                                </Row>
                                                            )}
                                                        </Col>
                                                        <Col md="6">
                                                            <FormGroup>
                                                                <Label for="deformityType">Deformity Type</Label>
                                                                <Input type="select" name="deformityType" id="deformityType" value={deformityType || ''} onChange={(e) => {
                                                                    const v = e.target.value;
                                                                    if (!v) return;
                                                                    if (v === 'ALL') { setSelectedDeformityTypes(deformityTypeAllValues); setDeformityType(''); return; }
                                                                    setSelectedDeformityTypes((prev) => prev.includes(v) ? prev : [...prev, v]);
                                                                    setDeformityType('');
                                                                }}>
                                                                    <option value="">Select Deformity Type</option>
                                                                    <option value="ALL">Select All</option>
                                                                    {[
                                                                        { value: '0', label: 'Normal' },
                                                                        { value: '1', label: 'Instability' },
                                                                        { value: '2', label: 'Mild' },
                                                                        { value: '3', label: 'Moderate' },
                                                                        { value: '4', label: 'Severe' },
                                                                        { value: '5', label: 'Very Severe' },
                                                                    ]
                                                                        .filter(opt => !selectedDeformityTypes.includes(opt.value))
                                                                        .map(opt => (<option key={opt.value} value={opt.value}>{opt.label}</option>))}
                                                                </Input>
                                                            </FormGroup>
                                                            {selectedDeformityTypes && selectedDeformityTypes.length > 0 && (
                                                                <Row>
                                                                    <Col md="12">
                                                                        <div className="mt-1" style={{ display: 'flex', flexWrap: 'wrap', gap: 8 }}>
                                                                            {selectedDeformityTypes.map((g) => (
                                                                                <Badge key={g} color="info" pill style={{ display: 'inline-flex', alignItems: 'center', paddingRight: 8 }}>
                                                                                    {getDeformityTypeLabel(g)}
                                                                                    <button type="button" onClick={() => removeDeformityType(g)} style={{ marginLeft: 8, border: 'none', background: 'transparent', color: 'inherit', cursor: 'pointer', lineHeight: 1 }} aria-label={`Remove ${getDeformityTypeLabel(g)}`}>×</button>
                                                                                </Badge>
                                                                            ))}
                                                                        </div>
                                                                    </Col>
                                                                </Row>
                                                            )}
                                                        </Col>
                                                    </Row>
                                                </Row>
                                                <Row className="mt-3">
                                                    <Col md="12" className="d-flex" style={{ gap: 10 }}>
                                                        <Button color="primary" onClick={(e) => { handleSearch(e) }}>Search</Button>
                                                        {selectedTab == 3 && (
                                                            <Button color="secondary" outline onClick={clearECDIFilters}>Clear Filters</Button>
                                                        )}
                                                    </Col>
                                                </Row>
                                            </div>
                                        </Col>
                                    </>
                                )}
                            </Row>
                        </div>
                        {selectedTab == 0 && (
                            <>
                                {treatmentDoneStats && (
                                    <div style={{ marginTop: '10px', marginBottom: '10px' }}>
                                        <Card className="main-card mb-3">
                                            <CardBody>
                                                <Row>
                                                    <Col md="4">
                                                        <div className="card mb-3 bg-arielle-smile widget-chart text-white card-border" style={{ cursor: 'pointer' }} onClick={(e) => { handleClick('treatmentDoneStats') }}>
                                                            <div className="icon-wrapper rounded-circle">
                                                                <div className="icon-wrapper-bg bg-white opacity-10" />
                                                                <i className="lnr-cog icon-gradient bg-arielle-smile" />
                                                            </div>
                                                            <div className="widget-subheading" style={{ marginTop: '5px' }}>Total Treatment Done</div>
                                                            <div className="widget-description text-white">
                                                                <span className="ps-1 fs-32">{treatmentDoneStats?.count}</span>
                                                            </div>
                                                        </div>
                                                    </Col>
                                                    <Col md="4">
                                                        <div className="card mb-3 bg-arielle-smile widget-chart text-white card-border" style={{ cursor: 'pointer' }} onClick={(e) => { handleClick('patientStatusStats') }}>
                                                            <div className="icon-wrapper rounded-circle">
                                                                <div className="icon-wrapper-bg bg-white opacity-10" />
                                                                <i className="lnr-cog icon-gradient bg-arielle-smile" />
                                                            </div>
                                                            <div className="widget-subheading" style={{ marginTop: '5px' }}>Patient Status <strong>({patientStatusAfter}) </strong></div>
                                                            <div className="widget-description text-white">
                                                                <span className="ps-1 fs-32">{patientStatusStats?.count}</span>
                                                            </div>
                                                        </div>
                                                    </Col>
                                                    <Col md="4">
                                                        <div className="card mb-3 bg-arielle-smile widget-chart text-white card-border" style={{ cursor: 'pointer' }} onClick={(e) => { handleClick('patientRegistrationStats') }}>
                                                            <div className="icon-wrapper rounded-circle">
                                                                <div className="icon-wrapper-bg bg-white opacity-10" />
                                                                <i className="lnr-cog icon-gradient bg-arielle-smile" />
                                                            </div>
                                                            <div className="widget-subheading" style={{ marginTop: '5px' }}>Total Patient Registration</div>
                                                            <div className="widget-description text-white">
                                                                <span className="ps-1 fs-32">{patientRegistrationStats?.count}</span>
                                                            </div>
                                                        </div>
                                                    </Col>
                                                </Row>
                                            </CardBody>
                                        </Card>
                                    </div>
                                )}
                            </>)}
                    </CardBody>
                </Card>
            )}
            {selectedTab == 1 && (
                <Card className="main-card mb-3">
                    <CardBody>
                        <CardTitle className="flex-space-between">
                            <div style={{ display: 'flex', justifyContent: 'flex-end', width: '100%' }}>
                                <Button color="primary" onClick={(e) => { handleDownload(e) }}>Download</Button>
                            </div>
                        </CardTitle>
                        <div className="table-responsive">
                            <Table striped className="mb-0" id="data-table">
                                <thead>
                                    <tr>
                                        <th>Patient Name</th>
                                        <th>MRN</th>
                                        <th>Status</th>
                                        <th>Spinal Diagnosis</th>
                                        <th>Apendicular Diagnosis</th>
                                        <th>BMI Score</th>
                                        <th>CDI Score</th>
                                        <th>ECDI Score</th>
                                        <th>Grade</th>
                                        <th>Duration</th>
                                        <th>Follow Up</th>
                                        <th>Sessions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {diagnosisReportData && diagnosisReportData?.map((item, index) => (
                                        <tr key={index}>
                                            <td>{item?.patient_info?.name}</td>
                                            <td>{item?.patient_info?.id}</td>
                                            <td>{item?.patient_info?.status ? item?.patient_info?.status : item?.status}</td>
                                            <td>{getSpinalDiagnosisName(item?.spinal)}</td>
                                            <td>{getRheumatoidArthritisName(item?.rheumatoid_arthritis)}</td>
                                            <td>{item?.patient_info?.bmi}</td>
                                            <td>{getTotalCdiScore(item?.cdi)}</td>
                                            <td>{getNameOfEcdi(item?.ecdi?.type)}</td>
                                            <td>{item?.grade?.grade == 1 ? 'Grade I' : item?.grade?.grade == 2 ? 'Grade II' : item?.grade?.grade == 3 ? 'Grade III' : 'Grade IV'}</td>
                                            <td>{item?.grade?.duration == 1 ? '6-12 Weeks' : item?.grade?.duration == 2 ? '12-16 Weeks' : item?.grade?.duration == 3 ? '16-24 Weeks' : 'More than 24 Weeks'}</td>
                                            <td>{item?.grade?.followUp == 1 ? 'As Per Need' : item?.grade?.followUp == 2 ? '24 Weeks' : item?.grade?.followUp == 3 ? '2 Years' : 'Life Time'}</td>
                                            <td>{item?.grade?.sessions == 1 ? '6-12' : item?.grade?.sessions == 2 ? '12-20' : item?.grade?.sessions == 3 ? '20-24' : '24-30'}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </Table>
                        </div>
                    </CardBody>
                </Card>
            )}
            {selectedTab == 0 && (
                <>
                    {detailData && (
                        <Card className="main-card mb-3">
                            <CardBody>
                                <CardTitle className="flex-space-between">{detailTitle}</CardTitle>
                                <div className="table-responsive">
                                    <Table striped className="mb-0">
                                        <thead>
                                            <tr>
                                                <th>Patient Name</th>
                                                <th>Status</th>
                                                <th>Center Name</th>
                                                <th>Treatment By</th>
                                                <th>Created At</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {detailData && detailData.map((item, index) => (
                                                <tr key={index}>
                                                    <td>{item?.patient_info?.name ? item?.patient_info?.name : item?.name}</td>
                                                    <td>{item?.patient_info?.status ? item?.patient_info?.status : item?.status}</td>
                                                    <td>{item?.center_info?.name}</td>
                                                    <td>{item?.user_created?.name}</td>
                                                    <td>{item?.created_at?.split ? item?.created_at.split('T')[0] : ''}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </Table>
                                </div>
                            </CardBody>
                        </Card>
                    )}
                </>)}
            {selectedTab == 2 && (<VisitProgressReport />)}
            {selectedTab == 4 && (<DpepReport />)}
            {selectedTab == 3 && (
                <Card className="main-card mb-3">
                    <Nav tabs className="mt-3">
                        <NavItem>
                            <NavLink href="#" active={viewTab === 'list'} onClick={(e) => { e.preventDefault(); setViewTab('list'); }}>List</NavLink>
                        </NavItem>
                        <NavItem>
                            <NavLink href="#" active={viewTab === 'graph'} onClick={(e) => { e.preventDefault(); setViewTab('graph'); }}>Graph</NavLink>
                        </NavItem>
                    </Nav>
                    <CardBody>
                        <CardTitle className="flex-space-between"><span>ECDI Report</span></CardTitle>
                        {isLoader && (
                    <div className="d-flex align-items-center justify-content-center" style={{ height: 200 }}>
                        <Spinner color="primary" />
                    </div>
                )}
                        {viewTab == 'list' ? (
                            <>
                                <div className="d-flex justify-content-between align-items-center" style={{ marginBottom: 10 }}>
                                    <div style={{ fontWeight: 'bold', fontSize: 24 }}>Total: {typeof eCDIReportDataCount === 'number' ? eCDIReportDataCount : (Array.isArray(eCDIReportData) ? eCDIReportData.length : 0)}</div>
                                    <div className="d-flex align-items-center" style={{ gap: 8 }}>
                                        <span>Rows per page:</span>
                                        <Input type="select" bsSize="sm" style={{ width: 90 }} value={eCDIRowsPerPage} onChange={handleECDIRowsPerPageChange}>
                                            <option value={10}>10</option>
                                            <option value={20}>20</option>
                                            <option value={50}>50</option>
                                        </Input>
                                    </div>
                                </div>

                                <div className="table-responsive">
                                    <Table striped className="mb-0" id="data-table">
                                        <thead>
                                            <tr>
                                                <th>Name</th>
                                                <th>MRN</th>
                                                <th>Age</th>
                                                <th>NIC</th>
                                                <th>Created At</th>
                                                <th>Records</th>
                                                <th>Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {(Array.isArray(eCDIReportData) ? eCDIReportData : []).map((p) => (
                                                <tr key={p.id}>
                                                    <td><span style={{ cursor: 'pointer', color: 'blue' }} onClick={(e) => { handleClickDashboard(e, p) }}>{p.name}</span></td>
                                                    <td><span style={{ cursor: 'pointer', color: 'blue' }} onClick={(e) => { handleClickDashboard(e, p) }}>{p.mrn}</span></td>
                                                    <td>{p.age}</td>
                                                    <td>{p.nic}</td>
                                                    <td>{p.created_at ? new Date(p.created_at).toLocaleDateString() : ''}</td>
                                                    <td>{Array.isArray(p.patient_ecdi_records) ? p.patient_ecdi_records.length : 0}</td>
                                                    <td>
                                                        <Button color="link" onClick={() => openEcdIModal(p)} title="View ECDI Records">
                                                            <FontAwesomeIcon icon={faEye} />
                                                        </Button>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </Table>
                                </div>
                            </>
                        ) : (
                            <>
                                <Row>
                                    <Col md="6">
                                        <Card className="main-card mb-3">
                                            <CardBody>
                                                <CardTitle className="flex-space-between"><span>Deformity (Grade)</span></CardTitle>
                                                <div style={{ marginBottom: 8, fontWeight: 600 }}></div>
                                                <div style={{ height: 360 }}>
                                                    {ecdiChartData?.deformity?.labels?.length > 0 ? (
                                                        <Doughnut data={ecdiChartData.deformity} options={chartOptionsDoughnut} />
                                                    ) : (
                                                        <div className="d-flex justify-content-center align-items-center h-100">No data</div>
                                                    )}
                                                </div>
                                            </CardBody>
                                        </Card>
                                    </Col>
                                    <Col md="6">
                                        <Card className="main-card mb-3">
                                            <CardBody>
                                                <CardTitle className="flex-space-between"><span>Deformity (Type)</span></CardTitle>
                                                <div style={{ marginBottom: 8, fontWeight: 600 }}></div>
                                                <div style={{ height: 360 }}>
                                                    {ecdiChartData?.type?.labels?.length > 0 ? (
                                                        <Doughnut data={ecdiChartData.type} options={chartOptionsDoughnut} />
                                                    ) : (
                                                        <div className="d-flex justify-content-center align-items-center h-100">No data</div>
                                                    )}
                                                </div>
                                            </CardBody>
                                        </Card>
                                    </Col>
                                </Row>
                            </>
                        )
                        }
                        {
                            eCDIReportDataCount > eCDIRowsPerPage && (
                                <div className="d-flex justify-content-end mt-3">
                                    <Pagination currentPage={eCDIPage + 1} totalPages={Math.ceil(eCDIReportDataCount / eCDIRowsPerPage)} onPageChange={handleECDIPageChange} />
                                </div>
                            )
                        }
                    </CardBody >
                </Card >
            )}
            <Modal isOpen={isEcdIModalOpen} toggle={closeEcdIModal} size="lg">
                <ModalHeader toggle={closeEcdIModal}>
                    ECDI Records {selectedEcdIPatient ? `- ${selectedEcdIPatient.name} (${selectedEcdIPatient.mrn})` : ''}
                </ModalHeader>
                <ModalBody>
                    <div className="table-responsive">
                        <Table striped className="mb-0">
                            <thead>
                                <tr>
                                    <th>#</th>
                                    <th>Record ID</th>
                                    <th>Created At</th>
                                    <th>Type</th>
                                    <th>Deformity Grade</th>
                                </tr>
                            </thead>
                            <tbody>
                                {selectedEcdIPatient && Array.isArray(selectedEcdIPatient.patient_ecdi_records) && selectedEcdIPatient.patient_ecdi_records.length > 0 ? (
                                    selectedEcdIPatient.patient_ecdi_records.map((r, idx) => (
                                        <tr key={r.id}>
                                            <td>{idx + 1}</td>
                                            <td>{r.id}</td>
                                            <td>{r.created_at ? new Date(r.created_at).toLocaleString() : ''}</td>
                                            <td>{getNameOfEcdi(String(r.type))}</td>
                                            <td>{getDeformityGradeOfEcdi(String(r.deformity_grade))}</td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan={5} className="text-center">No records found</td>
                                    </tr>
                                )}
                            </tbody>
                        </Table>
                    </div>
                </ModalBody>
                <ModalFooter>
                    <Button color="secondary" onClick={closeEcdIModal}>Close</Button>
                </ModalFooter>
            </Modal>
        </div >
    );
};

export default SuperAdminReporting;
